import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuditModelListPath } from "../../services/config";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  auditLoading: false,
  auditSuccess: false,
  auditError: false,
  auditMessage: null,

  auditGetLoading: false,
  auditGetSuccess: false,
  auditGetError: false,
  auditGetMessage: null,
  auditGetData: null,

  auditStaffLoading: false,
  auditStaffSuccess: false,
  auditStaffError: false,
  auditStaffMessage: null,
  auditStaffData: null,

  auditAssStaffLoading: false,
  auditAssStaffSuccess: false,
  auditAssStaffError: false,
  auditAssStaffMessage: null,
  auditAssStaffData: null,
};

const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;

const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchAuditModalData = createAsyncThunk(
  "fetchAuditModalData",
  async (data) => {
    const { userId, outletId } = data
    return await axios
      .get(`${baseUrl}${getAuditModelListPath(userId, outletId)}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const fetchAssAuditStaffData = createAsyncThunk(
  "fetchAssAuditStaffData",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const fetchAuditStaffData = createAsyncThunk(
  "fetchAuditStaffData",
  async (path) => {
    return await axios
      .get(`${baseUrl}${path}`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const saveUpdateDeleteAudit = createAsyncThunk(
  "saveUpdateDeleteAudit",
  async (body) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const { path, data } = body;

    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(`${baseUrl}${path}`, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              console.log(
                "You are offline. Please check your internet connection."
              );
            } else {
              console.log("An error occurred. Please try again later.");
            }
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          });
  }
);

const auditSlice = createSlice({
  name: "branch",
  initialState,

  reducers: {
    initState: (state) => {
      state.auditLoading = false;
      state.auditSuccess = false;
      state.auditError = false;
      state.auditMessage = null;

      state.auditGetLoading = false;
      state.auditGetSuccess = false;
      state.auditGetError = false;
      state.auditGetMessage = null;
    },
    initAuditState: (state) => {
      state.auditLoading = false;
      state.auditSuccess = false;
      state.auditError = false;
      state.auditMessage = null;

      state.auditGetLoading = false;
      state.auditGetSuccess = false;
      state.auditGetError = false;
      state.auditGetMessage = null;

      state.auditStaffLoading = false;
      state.auditStaffSuccess = false;
      state.auditStaffError = false;
      state.auditStaffMessage = null;

      state.auditAssStaffLoading = false;
      state.auditAssStaffSuccess = false;
      state.auditAssStaffError = false;
      state.auditAssStaffMessage = null;
      state.auditAssStaffData = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchAuditModalData.pending, (state, action) => {
      state.auditGetLoading = true;
      state.auditGetSuccess = false;
      state.auditGetError = false;
      state.auditGetMessage = null;
      state.auditGetData = null;
    });
    builder.addCase(fetchAuditModalData.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200) {
        state.auditGetLoading = false;
        state.auditGetSuccess = true;
        state.auditGetError = false;
        state.auditGetMessage = action.payload.data.message;
        state.auditGetData = action.payload.data.data;
      } else {
        state.auditGetLoading = false;
        state.auditGetSuccess = false;
        state.auditGetError = true;
        state.auditGetMessage = action.payload.response.data.message;
        state.auditGetData = null;
      }
    });
    builder.addCase(fetchAuditModalData.rejected, (state, action) => {
      state.auditGetLoading = false;
      state.auditGetSuccess = false;
      state.auditGetError = true;
      state.auditGetMessage = action.payload.data.message;
      state.auditGetData = null;
    });

    // Get Assigned Emp List
    builder.addCase(fetchAssAuditStaffData.pending, (state, action) => {
      state.auditAssStaffLoading = true;
      state.auditAssStaffSuccess = false;
      state.auditAssStaffError = false;
      state.auditAssStaffMessage = null;
      state.auditAssStaffData = null;
    });
    builder.addCase(fetchAssAuditStaffData.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200 || status == 201) {
        state.auditAssStaffLoading = false;
        state.auditAssStaffSuccess = true;
        state.auditAssStaffError = false;
        state.auditAssStaffMessage = action.payload.data.message;
        state.auditAssStaffData = action.payload.data.data;
      } else {
        state.auditAssStaffLoading = false;
        state.auditAssStaffSuccess = false;
        state.auditAssStaffError = true;
        state.auditAssStaffMessage = action.payload.response.data.message;
        state.auditAssStaffData = null;
      }
    });
    builder.addCase(fetchAssAuditStaffData.rejected, (state, action) => {
      state.auditAssStaffLoading = false;
      state.auditAssStaffSuccess = false;
      state.auditAssStaffError = true;
      state.auditAssStaffMessage = action.payload.data.message;
      state.auditAssStaffData = null;
    });

    // Get staff list
    builder.addCase(fetchAuditStaffData.pending, (state, action) => {
      state.auditStaffLoading = true;
      state.auditStaffSuccess = false;
      state.auditStaffError = false;
      state.auditStaffMessage = null;
      state.auditStaffData = null;
    });
    builder.addCase(fetchAuditStaffData.fulfilled, (state, action) => {
      const status = action.payload.status;

      if (status == 200) {
        state.auditStaffLoading = false;
        state.auditStaffSuccess = true;
        state.auditStaffError = false;
        state.auditStaffMessage = action.payload.data.message;
        state.auditStaffData = action.payload.data.data;
      } else {
        state.auditStaffLoading = false;
        state.auditStaffSuccess = false;
        state.auditStaffError = true;
        state.auditStaffMessage = action.payload.response.data.message;
        state.auditStaffData = null;
      }
    });
    builder.addCase(fetchAuditStaffData.rejected, (state, action) => {
      state.auditStaffLoading = false;
      state.auditStaffSuccess = false;
      state.auditStaffError = true;
      state.auditStaffMessage = action.payload.data.message;
      state.auditStaffData = null;
    });
    // To create branch
    builder.addCase(saveUpdateDeleteAudit.pending, (state, action) => {
      state.auditLoading = true;
      state.auditSuccess = false;
      state.auditError = false;
      state.auditMessage = null;
    });
    builder.addCase(saveUpdateDeleteAudit.fulfilled, (state, action) => {
      
      const status = action.payload.status;
      if (status == 200 || status == 201) {
        if(action.payload.data.status == true || action.payload.data.status == "true"){
          state.auditLoading = false;
          state.auditSuccess = true;
          state.auditError = false;
          state.auditMessage = action.payload.data.message;
        }else{
          console.log(action.payload.data)
          state.auditLoading = false;
          state.auditSuccess = false;
          state.auditError = true;
          state.auditMessage = action.payload.data.message;
        }
       
      } else {
        state.auditLoading = false;
        state.auditSuccess = false;
        state.auditError = true;
        state.auditMessage = action.payload.response.data.message;
      }

      // state.auditLoading = false;
      // state.auditSuccess = accountType == 2 ? false : true;
      // state.auditError = accountType == 2 ? true : false;
      // state.auditMessage = action.payload.data.message;
    });
    builder.addCase(saveUpdateDeleteAudit.rejected, (state, action) => {
      state.auditLoading = false;
      state.auditSuccess = false;
      state.auditError = true;
      state.auditMessage = action.payload.data.message;
    });
  },
});

export const { initState, initAuditState } = auditSlice.actions;

export default auditSlice.reducer;
